import {
  DtaAccountError,
  DtaAccountResponse,
  DtaAccountSearchResponse,
} from '../../../../api/generated';
import { ApiRequestStatus } from '../../../../model/api-request';

export interface FiduciarieSearchFilters {
  nome?: string;
  cognome?: string;
  ragioneSociale?: string;
  codiceClienteRappresentante?: string;
  codiceFiscale?: string;
  codiceFiscaleFiduciante?: string;
  addressBook?: string;
  partitaIva?: string;
}

export type FiduciarieValidationError =
  | 'minLength'
  | 'required'
  | 'fiscalDataRequired'
  | 'invalidFiscalCode'
  | 'invalidVatCode'
  | 'emailAlreadyInUse'
  | 'invalidField';

export type FiduciarieFieldErrors = Partial<
  Record<keyof FiduciarieSearchFilters, FiduciarieValidationError>
>;

// Paths of the DtaAccountRequest fields, as the server reports them in campiNonValidi.
export const DtaAccountField = {
  ActingPersonName: 'actingPerson.name',
  ActingPersonSurname: 'actingPerson.surname',
  ActingPersonCodiceFiscale: 'actingPerson.codiceFiscale',
  TrustCompanyName: 'trustCompany.name',
  TrustCompanyCode: 'trustCompany.code',
  TrustCompanyAgent: 'trustCompany.agent',
  TrustCompanyCodiceFiscale: 'trustCompany.codiceFiscale',
  TrustCompanyPartitaIva: 'trustCompany.partitaIva',
  ContactPhone: 'contact.phone',
  ContactEmail: 'contact.email',
  AddressBook: 'addressBook',
} as const;

export type DtaAccountField =
  (typeof DtaAccountField)[keyof typeof DtaAccountField];

export type DtaAccountFieldErrors = Partial<
  Record<DtaAccountField, FiduciarieValidationError>
>;

export interface FiduciarieState {
  searchDtaStatus: ApiRequestStatus;
  searchDtaResponse?: DtaAccountSearchResponse;
  searchDtaError?: DtaAccountError;

  createDtaStatus: ApiRequestStatus;
  createDtaResponse?: DtaAccountResponse;
  createDtaError?: DtaAccountError;

  deleteDtaStatus: ApiRequestStatus;
}

// Nested fields keyed by their path; fullName joins name and surname of the acting person.
export type FiduciarieTableColumns = 'username' | 'fullName' | DtaAccountField;
